<template>
  <div class="flex justify-between space-x-4">
    <div class="flex flex-col space-y-2">
      <lf-heading2 class="mb-0 h-8 relative top-px">{{ title }}</lf-heading2>
      <div v-if="description">{{ description }}</div>
    </div>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
import LfHeading2 from "@/components/ui/text/LfHeading2.vue";

defineProps<{
  title: string;
  description?: string;
}>();
</script>
